"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dropdown = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var DropdownMenu = __importStar(require("@radix-ui/react-dropdown-menu"));
var stitches_config_1 = require("../stitches.config");
var StyledDropdown = (0, stitches_config_1.styled)(DropdownMenu.Root, {});
var StyledDropdownContent = (0, stitches_config_1.styled)(DropdownMenu.Content, {
    background: stitches_config_1.theme.colors.white,
    padding: 4,
    gap: 4,
    boxShadow: stitches_config_1.theme.shadows.shadowSm,
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: stitches_config_1.theme.colors.gray7,
    borderRadius: stitches_config_1.theme.shape.borderRadius,
    minWidth: "256px",
    // TODO, fix this zIndex
    zIndex: 100000000,
    maxHeight: "var(--radix-dropdown-menu-content-available-height)",
    maxWidth: "var(--radix-dropdown-menu-content-available-width)",
    overflow: "auto",
});
var StyledDropdownTrigger = (0, stitches_config_1.styled)(DropdownMenu.Trigger, {
    outline: "none",
});
var WithPortal = function (props) {
    return props.portal ? ((0, jsx_runtime_1.jsx)(DropdownMenu.DropdownMenuPortal, { children: props.children })) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: props.children }));
};
function Dropdown(props) {
    var _a, _b;
    return ((0, jsx_runtime_1.jsxs)(StyledDropdown, { children: [(0, jsx_runtime_1.jsx)(StyledDropdownTrigger, __assign({ asChild: true }, { children: props.button })), (0, jsx_runtime_1.jsx)(WithPortal, __assign({ portal: props.portal }, { children: (0, jsx_runtime_1.jsx)(StyledDropdownContent, __assign({ collisionPadding: 4, side: (_a = props.position) !== null && _a !== void 0 ? _a : "bottom", sideOffset: 4, align: (_b = props.align) !== null && _b !== void 0 ? _b : "start" }, { children: props.children })) }))] }));
}
exports.Dropdown = Dropdown;
//# sourceMappingURL=Dropdown.js.map